import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
} from '@material-ui/core'
import { ClauseTitle, SimilarClausesButton, TagsHighlight, TextHighlight } from '../Atoms'
import { BookmarkButton } from '../Molecules'
import { isSimilarClausesPage } from '../../utils/UrlManipulation'

const useStyles = makeStyles(theme => ({
  root: {
    width: `100%`,
    cursor: 'pointer',
    boxShadow: theme.customShadows.primary.dark[0],
    margin: 1,
    '&:hover': {
      boxShadow: theme.customShadows.primary.dark[1],
    },
  },
  bold: {
    fontWeight: theme.typography.fontWeightBold
  },
  cardHeader: {
    paddingBottom: theme.spacing(0.5),
  },
  iconButtonHover: {
    justifyContent: 'center',
    padding: '0.5rem',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color: 'white',
    }
  },
}))

const ClauseCard = ({ clause, handleClickCard, isBookmarked, updateBookmarks, style }) => {
  const classes = useStyles()
  const { i18n } = useTranslation()

  const handleClickDocument = () => {
    if (window.getSelection().toString() === '') {
      handleClickCard()
    }
  }

  let { highlight, text } = clause
  const MAX_LINES = 10

  const deedType = clause[`deed_type_${i18n.language}`]
  const clauseType = clause.cluster_label

  const cardTitle = deedType

  const cardTags = [
    clause.date,
    ...clause[`tags_${i18n.language}`],
  ]

  if (clauseType) {
    cardTags.push(clauseType)
  }

  return (
    <Box width={1}>
      <Card
        style={style}
        elevation={0}
        raised
        classes={{ root: classes.root }}
        onClick={handleClickDocument}
      >
        <CardHeader
          className={classes.cardHeader}
          title={
            <Grid container justifyContent="space-between" alignItems="center">
              <ClauseTitle variant="body1" title={cardTitle} />
              <Grid container justifyContent="flex-end" alignItems="center" style={{ width: 150 }}>
                {parseInt(clause.similar_clauses_count) > 1 && !isSimilarClausesPage() && <SimilarClausesButton clause={clause} />}
                <BookmarkButton type="clause" variant="small" isBookmarked={isBookmarked} updateBookmarks={updateBookmarks} />
              </Grid>
            </Grid>
          }
          subheader={
            <TagsHighlight tags={cardTags} tags_highlight={clause.highlight && clause.highlight.tags_highlight} />
          }
        />
        <CardContent style={{ paddingTop: 0 }}>
          <TextHighlight
            text={text}
            highlighted_text={
              highlight
              && highlight.text_highlight
              && highlight.text_highlight.length > 0
              && highlight.text_highlight
            }
            maxLines={MAX_LINES}
          />
        </CardContent>
      </Card>
    </Box >
  )
}

export default ClauseCard
